export function makeSafeIsoDateString(dateString: string) {
  if (dateString.indexOf('T') < 0) {
    return `${dateString}T00:00:00`;
  }

  return dateString;
}
